import $ from 'jquery'
import { gsap } from 'gsap';
import 'lity';
import { unitSliderInit, unitSliderDestroy } from './unit-slider';

const $component = $('.c-floorplans'),
      mqDesktop  = matchMedia('(min-width: 1200px)'),
      mqXL       = matchMedia('(min-width: 1440px)'),
      mqXXL      = matchMedia('(min-width: 1600px)');

function floorPlan() {
  
  if( $component.length ) {
    init();
  }
}

function init() {
  let $component = $('.c-floorplans');
  
  // Set component to start on step 1
  $component.data('currentStep', 1);
  
  slideSelector();  
  updateSlideWidths();
  slide1HoverHandler();
  step2FeatureHoverHandler();
  modalHandler();
  
  $(window).resize(debounce(responsiveHandler))
}

function responsiveHandler() {
  const currentStep = getStep();
  
  updateSlideWidths();
  
  requestAnimationFrame(function() {    
    updateTrackPosition(currentStep);
  });
}

function slideSelector() {
  const $slides = $('.c-floorplans_slide');
  
  $('.c-floorplans_slide').on('click', function(e) {
    let visibleNotActive = $(this).hasClass('is-visible') && !$(this).hasClass('is-active');
    
    if( visibleNotActive ) {
      e.preventDefault();
      
      let $currentSlide = getCurrentSlide(), 
      currentStep   = getStep(),
      $newSlide     = $(this),
      newStep       = $newSlide.attr('data-step');
      
      if( newStep == 1 ) {
        $newSlide.find('svg .is-selected').removeClass('is-selected');
      }
      
      hideSlidesByStep($newSlide.attr('data-step'));
      $currentSlide.removeClass('is-active is-visible');
      $newSlide.addClass('is-visible is-active');
      setStep(newStep);          
    }
  })  
  
  $('a[data-back]').on('click', function(e) {    
    e.preventDefault();
    
    let slug          = $(this).attr('data-back'),
        $currentSlide = getCurrentSlide(),
        $newSlide     = getSlideBySlug(slug),
        newStep       = $newSlide.attr('data-step');
    
    if( newStep == 1 ) {
      $newSlide.find('svg .is-selected').removeClass('is-selected');
    }
    
    $currentSlide.removeClass('is-visible is-active');
    $newSlide.addClass('is-active');
    setStep(newStep);
  })
  
  $('svg [data-show]').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    let $svg          = $(this).parents('svg'),
        slug          = $(this).attr('data-show'), 
        $currentSlide = getCurrentSlide(), 
        currentStep   = getStep(),
        $newSlide     = getSlideBySlug(slug),
        newStep       = $newSlide.attr('data-step');
        
    if( currentStep === 1 ) {
      $svg.find('polygon[data-show]').removeClass('is-selected');
      $(this).addClass('is-selected');
    } 
        
    hideSlidesByStep($newSlide.attr('data-step'));
    $currentSlide.removeClass('is-active');
    $newSlide.addClass('is-visible is-active');
    setStep(newStep);
  });
}

function hideSlidesByStep(step) {
  const $slides = $(`.c-floorplans_slide[data-step="${step}"]`); 
  
  $slides.removeClass('is-visible');
}

function getSlideBySlug(slug) {
  return $(`.c-floorplans_slide[data-slug="${slug}"]`); 
}

function getCurrentSlide() {
  let step = getStep(); 
  
  return $(`.c-floorplans_slide[data-step=${step}].is-active`)
}

function setStep(currentStep) {
  let prevStep    = $component.data('currentStep');
  
  currentStep = parseInt(currentStep);
  
  $component.data('prevStep', prevStep)
  $component.data('currentStep', currentStep);
  
  updateTrackPosition(currentStep, prevStep);
}

function updateTrackPosition(currentStep, prevStep) {
  let $currentSlide = $component.find(`.c-floorplans_slide[data-step="${currentStep}"].is-visible`),
      currentBox    = $currentSlide[0].getBoundingClientRect(),
      trackSelector = '.c-floorplans_track',
      trackBox      = document.querySelector(trackSelector).getBoundingClientRect(),
      box           = {
        left: currentBox.left - trackBox.left,
        right: currentBox.left - trackBox.left + currentBox.width - window.innerWidth,
        width: currentBox.width
      },
      direction     = currentStep > prevStep ? 'forward' : 'reverse',
      offset        = 0;

  // console.table(prevBox)
  // console.table(currentBox)
  // console.table(trackBox)
  // console.table(box);
        
  if( currentStep == 2 ) {
    offset = box.left - (window.innerWidth * .3);
  }
  else if( currentStep == 3 ) {
    let multiplier = mqXXL.matches ? .6 : .3;
    
    offset = box.left - (window.innerWidth * .3);
  }
  
  if( !mqDesktop.matches ) {
    offset = box.left;
  }
  
  gsap.to(trackSelector, {
    duration: 1,
    x: offset * -1,
    ease: 'power2.out'
  });
  
  slide1AnimationHandler(currentStep, prevStep);
}

function updateSlideWidths() {
  let $slides       = $component.find('.c-floorplans_slide'),
      $containers   = $slides.find('.container'),
      $slide1       = $slides.filter('[data-step=1]'),
      slide1Width   = $slide1.outerWidth(),
      $step2Slides  = $slides.filter('[data-step=2]'),
      step2MinWidth = 0, 
      $step3Slides  = $slides.filter('[data-step=3]'),
      step3MinWidth = 0,
      $track        = $component.find('.c-floorplans_track');
  
  $step2Slides.each(function() {
    let width = $(this).outerWidth();
    
    if( step2MinWidth < width ) {
      step2MinWidth = width;
    }
  });
  
  $step3Slides.each(function() {
    let width = $(this).outerWidth();
    
    if( step3MinWidth < width ) {
      step3MinWidth = width;
    }    
  });  
  
  $track.outerWidth(slide1Width + step2MinWidth + step3MinWidth);
}

function getStep() {
  return $component.data('currentStep');
}

function getPrevStep() {
  return $component.data('prevStep');
}

function slide1HoverHandler() {
  let $slide1Content = $component.find('.c-floorplans-main'),
      $svg           = $slide1Content.find('svg');
  
  $slide1Content.find('.c-floor').hover(function() {
    var floor  = $(this).attr('data-floor'),
        $text  = $(`#floor-text-${floor}`);
    
    $text.addClass('is-visible');    
  },  
  function() {
    var floor  = $(this).attr('data-floor'),
        $text  = $(`#floor-text-${floor}`);
    
    $text.removeClass('is-visible');
  });
}

function slide1AnimationHandler(currentStep, prevStep) {
  let $slide1Content = $component.find('.c-floorplans-main');
  
  if( mqXXL.matches ) {    
    if( currentStep == 2 && prevStep == 1 ) {    
      gsap.to($slide1Content[0], {
        duration: .5,
        x: '15%',
        ease: 'power2.out'
      })
    }
    else if( currentStep == 1 && prevStep == 2 ) {
      gsap.to($slide1Content[0], {
        duration: .5,
        x: 0,
        ease: 'power2.out'
      })    
    }  
  }
  else {
    gsap.set($slide1Content[0], {x: 0});
  }
}

function step2FeatureHoverHandler() {
  const $slides = $component.find('.c-floorplans_slide[data-step=2]');
  
  $slides.each(function() {
    const $shapes  = $(this).find('.c-floorplan_unit'),
          $details = $(this).find('.c-floorplan_unit-details') 
    
    $shapes.hover(function() {
      let slug = $(this).attr('data-show');
      
      $details.html(getUnitDetailsHTML(slug));      
      $details.addClass('is-visible');
    }, function() {
      let slug = $(this).attr('data-show');
      
      $details.html('');
      $details.removeClass('is-visible');
    });
  })
  
}

function getUnitDetailsHTML(slug) {
  let details  = getUnitDetails(slug),
      html     = '';
  
  for( let key in details ) {
    let value = details[key];
    
    if( key && value ) {
      
      let template = `<div class="c-unit-detail">
        <h4 class="c-unit-detail_label">${key}</h4>
        <div class="c-unit-detail_value">${value}</div>
      </div>`; 
      
      html += template;
    }    
    
  }
  
  return html;
}

function getUnitDetails(slug) {
  let $slide         = getSlideBySlug(slug),
      bedrooms       = $slide.find('[data-label="Bedrooms"]').text(),
      bathrooms      = $slide.find('[data-label="Bathrooms"]').text(),
      floor          = $slide.find('[data-label="Located On"]').text(),
      den            = $slide.find('[data-label="Den"]').text(),
      denAsOffice    = $slide.find('[data-den-as-office]').attr('data-den-as-office'),
      denLabel       = denAsOffice == true ? 'Den/Office' : 'Den',
      sqFootage      = $slide.find('[data-label="Sq Ft."]').text(),
      residenceStyle = $slide.find('[data-label="Residence Style"]').text(); 
  
  return {
    'Residence Style': residenceStyle,
    'Bedrooms': bedrooms,
    'Bathrooms': bathrooms,
    [denLabel]: den,
    'Located On': floor,
    'Sq Ft.': sqFootage
  };
}

function debounce( fn ) {
  var timeout;
  
  return function debounced() {
    var _this = this,
        args  = arguments;

    // If there's a timer, cancel it
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    // Setup the new requestAnimationFrame()
    timeout = window.requestAnimationFrame(function () {
      fn.apply( _this, args );
    });
  }
}

function modalHandler() {
  $(document).on('lity:ready', function(event, instance) {   
    try {      
      unitSliderInit();
    }
    catch(error) {
      console.error(error);
    }    
  });  
  
  $(document).on('lity:close', function(event, instance) {    
    try {      
      unitSliderDestroy();
    }
    catch(error) {
      console.error(error);
    }
  });  
}

export { floorPlan }